import {Stack} from '@mui/material'
import {SidebarMenuMain} from './SidebarMenuMain'

const SidebarMenu = ({activeMenu, setIsOpen}: any) => {
  return (
    <div className='app-sidebar-menu overflow-hidden flex-column-fluid'>
      <div
        style={{
          overflowY: 'auto',
          overflowX: 'hidden',
          minHeight: '60vh',
          maxHeight: '68vh',
          height: '50vh',
        }}
        id='kt_app_sidebar_menu_wrapper'
        className='app-sidebar-wrapper hover-scroll-overlay-y my-5'
        data-kt-scroll='true'
        data-kt-scroll-activate='true'
        // data-kt-scroll-height='auto'
        data-kt-scroll-dependencies='#kt_app_sidebar_logo, #kt_app_sidebar_footer'
        data-kt-scroll-wrappers='#kt_app_sidebar_menu'
        data-kt-scroll-offset='5px'
        data-kt-scroll-save-state='true'
      >
        <div
          className='menu menu-column menu-rounded menu-sub-indention px-3'
          id='#kt_app_sidebar_menu'
          data-kt-menu='true'
          data-kt-menu-expand='false'
        >
          <SidebarMenuMain setIsOpen={setIsOpen} activeMenu={activeMenu} />
        </div>
      </div>
    </div>
  )
}

export {SidebarMenu}
